import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "content"]

  connect() {
    document.addEventListener("keydown", this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  open(event) {
    event?.preventDefault()
    if (this.hasContainerTarget) {
      this.containerTarget.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    }
  }

  close(event) {
    event?.preventDefault()
    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.containerTarget) {
      this.close()
    }
  }
}
